import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandTakeTemplateAddPage } from '../cabsand-take-template-add/cabsand-take-template-add';
@IonicPage()
@Component({
  selector: 'page-cabsand-take-5',
  templateUrl: 'cabsand-take-5.html',
})
export class CabsandTake_5Page {
  templateList:any = [];
  actionAllowed:boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad KlmrTake_5Page');
    this.getMetaData();
  }

  async getMetaData(){
    this.utiltiy.startLoading();
    let templates = await this.getData("get_template");
    this.calculateTemplateList(templates);
    this.utiltiy.stopLoading();

    console.log("templates",templates)
  }

  async calculateTemplateList(templateList){
   
    let array = [];
    let keys = Object.keys(templateList);
    keys.forEach(element => {
      let monthKeys = Object.keys(templateList[element].months)
      let childArray = [];
      let obj = {} as any;
      obj.name = element;
      monthKeys.forEach(element_ => {
        const monthNames = ["","January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
        ];
        childArray.push({"records":templateList[element].months[element_], "monthName": monthNames[element_]})
      });
      obj.children = childArray
      array.push(obj)
    });
    console.log("array",array)
    this.templateList = array;
  }

  templatetoggleSection(i){
    this.templateList[i].open = !this.templateList[i].open;
  }

  templatetoggleItem(i,j){
    this.templateList[i].children[j].open = ! this.templateList[i].children[j].open;
  }

  buyItem(item){
    console.log(item)
  }

  previewTemplate(template){
console.log("template",template)
this.navCtrl.push(CabsandTakeTemplateAddPage, { param: template,disabled:true });

  }


  async getData(method){
    let formData: FormData = new FormData();
    formData.append("method_name", method);
    // formData.append("folder_name", "klmr");
    return this.api.post("/tansix_prestart/take_5/Templates", false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

}
}



// WEBPACK FOOTER //
// ./src/pages/cabsand-take-5/cabsand-take-5.ts